"use client";

import { c as _c } from "react/compiler-runtime";
type RadioFieldProps = {
  label: string;
  value?: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  className?: string;
};
export default function RadioField(t0) {
  const $ = _c(13);
  const {
    label,
    value,
    checked: t1,
    onChange,
    className: t2
  } = t0;
  const checked = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `flex items-center gap-2 cursor-pointer text-14-tamil-400 bg-FFFFFF text-808080-800 ${className}`;
  let t4;
  if ($[0] !== onChange || $[1] !== value) {
    t4 = () => onChange?.(value || "");
    $[0] = onChange;
    $[1] = value;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== checked || $[4] !== t4 || $[5] !== value) {
    t5 = <input type="radio" value={value} checked={checked} onChange={t4} className="w-4 h-4 accent-[#002a63] cursor-pointer" />;
    $[3] = checked;
    $[4] = t4;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = <span>{label}</span>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <label className={t3}>{t5}{t6}</label>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}